module.exports = __webpack_public_path__ + "static/media/landing_image_healthcare.d0571a47.jpg";